// Returns the amount of ethereum used for a transaction
// from the server, as a number unit.

export default function getFeeAmount(asset, serverTx) {
  const { gas: gasLimit, gasUsed, gasPrice } = serverTx

  // genesis, coinbase, uncles
  if (!gasPrice) return asset.currency.ZERO

  return asset.currency.baseUnit(gasUsed || gasLimit).mul(gasPrice)
}
